module.exports = __webpack_public_path__ + "static/media/paperclip.fd5d03ee.svg";